
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.43 16A2.3 2.3 0 1125 16v9","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M15.84 17v-3.11a2.3 2.3 0 014.59 0V25","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M25 19.65a2.3 2.3 0 014.6 0V34a4.6 4.6 0 01-4.6 4.61H13.54c-1.27 0-8.24-8.5-8.24-9.77a2.3 2.3 0 012.3-2.3c1.27 0 2.11 1.54 3.64 3.07V16a2.3 2.3 0 114.6 0v9M29.62 6.52a2.3 2.3 0 014.6 0v8M25 7.47V4.41a2.3 2.3 0 114.59 0v10.12","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M20.43 13.13V6.52a2.3 2.3 0 014.6 0v9M34.22 10.17a2.3 2.3 0 114.59 0v14.36a4.6 4.6 0 01-4.59 4.6h-4.63M.76 1.96l7.5 7.5M11.91 1.39v5.93M.19 13.1h5.93","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    